import { SolidDashMultipleLinesChart } from "../ChartJs";
import React from "react";
import { LongText, prefixValue, suffixValue, Unit } from "../processors";
import { CategoryTheme } from "../misc";
import { getTraceColors } from "../../themes";
import { Paragraph } from "../Paragraph";
import styles from "./MultipleLinesWithAverageData.module.scss";

import { useYearsCleaner } from "./useYearsCleaner";

export interface MultipleLinesWithAverageDataProps {
    measure: string;
    unit?: Unit;
    years: number[];
    linesDataSeriesName: string[];
    linesData: number[][];

    // largeProviderAverageData: number[];
    // largeProviderAverageSeriesName: string;

    providerMedianData: number[][];
    providerMedianSeriesNames: string[];
    providerMedianAnnotations: string[];

    theme?: CategoryTheme;
    header?: LongText;
    footer?: LongText;
}

export const MultipleLinesWithAverageData: React.FC<MultipleLinesWithAverageDataProps> = ({
    unit,
    header,
    footer,
    theme,
    years,
    linesData,
    linesDataSeriesName,
    measure,

    providerMedianData,
    providerMedianSeriesNames,
    providerMedianAnnotations

    // largeProviderAverageData,
    // largeProviderAverageSeriesName
}) => {
    const {
        years: _years,
        linesData: _linesData,
        providerMedianData: _providerMedianData
    } = useYearsCleaner(years, linesData, providerMedianData);

    if (!_years?.length || !_linesData?.length || !_providerMedianData.length) return null;

    const colors = getTraceColors(theme, linesDataSeriesName.length);

    return (
        <>
            {header != null && (
                <Paragraph
                    nid={0}
                    status={true}
                    title={""}
                    text={header}
                    className={`marginBottom headline chart-headline`}
                />
            )}
            <div className={styles.legendSpace}>
                {(linesDataSeriesName ?? []).map((name, index) => {
                    return (
                        <div key={index} className={styles.legendContainer}>
                            <div
                                className={styles.legend}
                                style={{
                                    background: colors[index]
                                }}
                            ></div>
                            <div className={styles.legendText}>{name}</div>
                        </div>
                    );
                })}
            </div>
            <SolidDashMultipleLinesChart
                measure={measure}
                unit={unit}
                labels={_years}
                // dashAnnotation={"Large provider median"}
                // dashLabel={largeProviderAverageSeriesName}
                // dashValues={largeProviderAverageData}

                dashValues={_providerMedianData}
                dashLabels={providerMedianSeriesNames}
                dashAnnotations={providerMedianAnnotations}
                solidLinesValues={_linesData}
                solidLabels={linesDataSeriesName}
                solidColors={colors}
                yAxisLabelFormatter={value => {
                    return `${prefixValue(value, unit) ?? ""}${value}${suffixValue(value, unit) ?? ""}`;
                }}
            />
            {footer != null && <Paragraph nid={0} status={true} title={""} text={footer} />}
        </>
    );
};
